export const GROUP_COLUMN_PREFIX = 'ag-Grid-AutoColumn';
export const NULL_GROUPING = '__null_grouping__';

export const LOCATION_AGGREGATION_TYPES = ['count'];
export const NUMERICAL_HIERARCHY_AGGREGATION_TYPES = ['sum', 'count', 'avg', 'min', 'max'];
export const NON_NUMERICAL_HIERARCHY_AGGREGATION_TYPES = ['count', 'min', 'max'];
